/**
 * Rewrites self-closing XML tags (`<foo ... />`) as explicit open/close pairs
 * (`<foo ...></foo>`), which `html-react-parser` (used to render the
 * Blockly-generated block XML as JSX) requires for elements it doesn't
 * already treat as void.
 *
 * Shared by MyBlocks/index.js and MyBlocks/MyBlockSearch.js, which both
 * render a library's saved blocks from the same Blockly-XML-to-JSX pipeline.
 *
 * @param {string} xml - XML string potentially containing self-closing tags.
 * @returns {string} XML string with self-closing tags expanded.
 */
export function removeSelfClosingTags(xml) {
    let split = xml.split('/>');
    let newXml = '';
    for (let i = 0; i < split.length - 1; i++) {
        let edsplit = split[i].split('<');
        newXml += split[i] + '></' + edsplit.at(-1).split(' ')[0] + '>';
    }
    return newXml + split.at(-1);
}
